import React from 'react';

import { fetchAreas, fetchDeficiencyCodes, updateFilter } from "../../redux/action/filter.action";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import { ErrorMessage, Formik } from "formik";
import Select from "react-select";
import { useEffect } from "react";
import { useRef } from "react";
import { changeCompany } from "../../redux/action/user.action";
import '../styles/suggestions_style.css'
import { cleanSuggestions, getCompanySuggestions } from '../../redux/action/suggestions.action'
import Autosuggest from 'react-autosuggest';
import { useState } from "react";

const Filters = ({ }) => {
  const dispatch = useDispatch(); // Works!
  const location = window.location // Access query parameters

  const queryParams = new URLSearchParams(location.search);

  let areas = useSelector(state => state.companyVesselChartData.areas);
  let companies = useSelector(state => state.user.companies)
  let settings = useSelector(state => state.user.settings);
  const [value, setValue] = useState(queryParams.get("filterCompanyName") || '');
  const [filterCompanyId, setFilterCompanyId] = useState(queryParams.get("filterCompanyId") || null);
  const [currentSuggestion, setCurrentSuggestion] = useState({});
  const suggestions = useSelector(state => state.suggestions);
  let deficiencyCodes = useSelector(state => state.companyVesselChartData.deficienciesCodes);
  let filter = useSelector(state => state.filter);
  const filterRef = useRef(filter);
  filterRef.current = filter;

  let vesselDetail = useSelector(state => state.vessel.detail);

  const currentCompany = useRef(null);
  let company = useSelector(state => state.user.company)
  let [detailValueForSearch, setDetailValueForSearch] = useState("");

  let currentFilterSerial = useSelector(state => state.filter.filterSerial);


  useEffect(() => {
    if (vesselDetail) {
      setDetailValueForSearch(vesselDetail?.detailValueForSearch || "");
    }
  }, [vesselDetail]);

  return (
    <Formik
      initialValues={{ myPort: true, dateFrom: queryParams.get("dateFrom") ? new Date(queryParams.get("dateFrom")) : new Date(new Date().setDate(new Date().getDate() - 14)) }}
      enableReinitialize={true}
      validate={values => {
        const errors = {};
        return errors;
      }}
      onSubmit={(values) => {
        dispatch(updateFilter({ keyword: detailValueForSearch }));
      }}>
      {({ values, errors, handleSubmit, setFieldValue, setValues, submitForm }) => (
        <form onSubmit={handleSubmit} autoComplete="off" className="rd-form rd-mailform">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="relate">Detail Value<ErrorMessage name="relatedItems" render={msg => <span className="error">(*{msg})</span>} /></label>
                {/* Input field and search button */}
                <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                  <input
                    type="text"
                    name="searchText"
                    placeholder="Enter search term"
                    value={detailValueForSearch || ''}
                    onChange={e => setDetailValueForSearch(e.target.value)}
                    className="form-control"
                  />
                  <button type="submit" className="btn btn-primary btn-small btn-green">Search</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>

  );
};

export default Filters;